import { useMemo } from 'react'
import { useTranslations } from '@/lib/next-shim'
import { Maybe } from '@/core/graphql/types'

import type { MedecinData, ProfessionalInfo } from './types'

export function useProfessionalInfo(medecin: MedecinData): ProfessionalInfo {
  const t = useTranslations()

  return useMemo(() => {
    const { userInfo, civility, title, speciality, teleconsultationTraining, cabinetAddresses = [] } = medecin
    const civilityLabel = civility ? t(`enum.Civility.${civility}`) : ''
    const fullName = `${civilityLabel ? civilityLabel + ' ' : ''}${userInfo.name ?? ''} ${userInfo.surname ?? ''}`.trim()

    const hasTraining = !!(teleconsultationTraining?.type && teleconsultationTraining.type !== 'NONE')
    const trainingLabel = hasTraining ? t(`enum.TrainingType.${teleconsultationTraining!.type}`) : ''
    const trainingDescription = hasTraining ? teleconsultationTraining!.description : undefined

    const validAddresses = (cabinetAddresses ?? []).filter(
      (a): a is { description?: Maybe<string> } => a != null && !!a.description,
    )

    return { fullName, title, speciality, hasTraining, trainingLabel, trainingDescription, validAddresses }
  }, [medecin, t])
}
